<template>
  <div>
    <div 
      id="delivery" 
      class="modal fade show"  
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="delivery" 
      aria-hidden="false"
      style="display: block;"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-container">
            <div class="modal-header">
              <h5 class="modal-title">DRIVER</h5>
            </div>
            <div class="modal-body1 d-flex flex-column justify-content-between">
              <div 
                v-if="loading"
                class="text-center py-4"
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div 
                v-else
                class="driver-grid d-flex flex-row flex-wrap align-items-start"
              >
                <div 
                  v-for="driver in drivers" 
                  :key="driver.id" 
                  class="carddriver d-flex flex-column justify-content-center align-items-center"
                  :class="{ 'selected-driver': selectedDriverId === driver.id }"
                  @click="selectDriver(driver.id)"
                >
                  <span>{{ driver.name }}</span>
                  <small class="text-muted">{{ driver.carNumber }}</small>
                </div>
                <div v-if="drivers.length === 0" class="w-100 text-center py-4">
                  No drivers available
                </div>
              </div>
              <div class="buttons d-flex flex-row justify-content-end">
                <button class="cancle" @click="closeModal"> 
                  <span>back</span>
                </button>
                <button 
                  class="submit"
                  :disabled="!selectedDriverId"
                  @click="submitSelectedDriver"
                > 
                  <span>submit</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Backdrop -->
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: 'DriverModal',
  data() {
    return {
      drivers: [],
      loading: false,
      error: null,
      selectedDriverId: null
    }
  },
  mounted() {
    this.fetchDrivers();
  },
  methods: {
    async fetchDrivers() {
      this.loading = true;
      this.error = null;
      
      try {
        this.$root.isLoading = true; 
          this.loading = true;
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${this.$BASE_API_URL}/api/drivers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch drivers');
        }

        const result = await response.json();
        
        if (result.status && result.data) {
          this.drivers = result.data;
        } else {
          throw new Error(result.message || 'Invalid response format');
        }
      } catch (error) {
        console.error('Error fetching drivers:', error);
        this.error = error.message;
      } finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
    },
    selectDriver(driverId) {
      this.selectedDriverId = driverId;
    },
    closeModal() {
      this.$emit('close');
    },
    submitSelectedDriver() {
      if (this.selectedDriverId) {
        this.$emit('submit', this.selectedDriverId);
        this.closeModal();
      }
    }
  }
}
</script>

<style scoped>
.modal-container {
  margin: 25px; 
  background: rgba(89, 97, 87, 1);
  border-radius: 5px;
  height: 100%;
}

.driver-grid {
  max-height: 540px;
  margin-bottom: 16px;
  overflow-y: auto;
}

.carddriver {
  width: 120px;
  height: 80px;
  margin: 8px;
  background: #fff;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.carddriver:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.selected-driver {
  background-color: #4CAF50;
  color: white;
}

.selected-driver .text-muted {
  color: #e0e0e0 !important;
}

.buttons {
  padding: 10px 0;
}

.cancle, .submit {
  padding: 8px 20px;
  margin-left: 10px;
  cursor: pointer;
  border-radius: 4px;
  border: none;
}

.cancle {
  background: #ccc;
}

.submit {
  background: #4CAF50;
  color: white;
}

.submit:disabled {
  background: #cccccc;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Make the modal appear as default */
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: scroll;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
  opacity: 0.5;
}
</style>